import styled from '@emotion/styled';
import { createStyles } from '@material-ui/core/styles';
import { theme } from '../styles/theme';

export const DatePickerWrapper = styled('section')`
  position: relative;
`;

export const IonwWrapper = styled('section')`
  position: absolute;
  left: 12px;
  top: 7px;
  width: 18px;
  height: 18px;
  font-size: 18px;
  color: ${theme.color.primary.default};
`;

export const popOverStyles = createStyles({
  root: {
    boxShadow: `0 1px 6px 0 rgba(69, 69, 69, 0.2),
      0 1px 5px 0 rgba(69, 69, 69, 0.1)`
  }
});

export const inputStyles = createStyles({
  root: {
    paddingLeft: '30px'
  }
});

const styles = createStyles({
  root: {
    maxWidth: '128px',
    width: '100%',
    height: '32px'
  }
});

export default styles;
